// Public, logged-out landing for The Freaks (reached from /about). Kept separate
// from localization/theFreaks/*, which is a 1:1 copy of the mobile game strings.
// `demo` holds the captions of the public auto-playing demo (/freaks-demo, TheFreaksDemoView).
const theFreaksGuideTranslations = {
  en: {
    badge: 'Daily game',
    title: 'The Freaks',
    subline: 'The daily Freakland game for your activity — play on the web or in the app, your progress is the same everywhere.',
    stepsHeading: 'How it works',
    steps: [
      { emoji: '🎯', title: 'Pick your activity', desc: 'Off-road, fishing, running and more. Missions, gear and base follow the activity you play as.' },
      { emoji: '⚡', title: 'Do missions', desc: 'Real things to do in your activity, tier 1 to 10. Wins give cash and respect; energy refills by itself.' },
      { emoji: '💪', title: 'Train & gear up', desc: 'Raise Strength, Skill, Endurance and Charisma, and buy real kit that boosts your stats.' },
      { emoji: '🏠', title: 'Build a base', desc: 'A garage, a bait shop… it earns cash per hour while you\'re away.' },
      { emoji: '🥊', title: 'Challenge freaks', desc: 'Challenge players with similar respect and take part of their cash. Newcomers are protected for 7 days.' },
      { emoji: '🎁', title: 'Daily prize & quests', desc: 'Claim a prize every day, finish 3 daily quests and keep your streak going.' },
    ],
    prizesHeading: 'Win real Freak Points',
    prizes: 'Top 3 of each day win 30 / 20 / 10 Freak Points on the Top Freaks board, and the top 3 of the month win 100 / 50 / 25 FP and a medal.',
    ctaHeading: 'Ready to play?',
    ctaSubline: 'Create a free account or log in to start playing The Freaks.',
    register: 'Join free',
    login: 'Log in',
    back: 'Back to About',
    watchDemo: 'Watch the demo',
    demo: {
      badge: 'Demo',
      captions: {
        intro: { title: 'This is The Freaks', text: 'The daily Freakland game for your activity. Here: off-road.' },
        daily: { title: 'Claim your daily prize', text: 'Come back every day — the streak pays more.' },
        mission: { title: 'Do missions', text: 'Real off-road things to do. Wins give cash and respect.' },
        repeat: { title: 'Short on time?', text: 'Repeat a mission ×5 in one tap.' },
        train: { title: 'Train your stats', text: 'Strength, Skill, Endurance, Charisma — each has a job.' },
        gear: { title: 'Gear up', text: 'Real kit boosts your stats while you play.' },
        base: { title: 'Run your base', text: 'Your garage earns cash every hour, even when you\'re away.' },
        fight: { title: 'Challenge freaks', text: 'Beat players with similar respect and take part of their cash.' },
        outro: { title: 'Climb the Top Freaks', text: 'Top 3 of the day win real Freak Points. Your turn!' },
      },
      play: 'Play',
      pause: 'Pause',
      next: 'Next',
      previous: 'Previous',
      restart: 'Restart',
      step: 'Step %{step} of %{total}',
      backToGuide: 'Back to the guide',
    },
  },
  pl: {
    badge: 'Codzienna gra',
    title: 'The Freaks',
    subline: 'Codzienna gra Freaklandu dla Twojej aktywności — graj w przeglądarce albo w aplikacji, postęp jest wszędzie ten sam.',
    stepsHeading: 'Jak to działa',
    steps: [
      { emoji: '🎯', title: 'Wybierz aktywność', desc: 'Off-road, wędkarstwo, bieganie i więcej. Misje, sprzęt i baza zależą od aktywności, którą grasz.' },
      { emoji: '⚡', title: 'Wykonuj misje', desc: 'Prawdziwe zadania z Twojej aktywności, poziomy 1–10. Wygrane dają kasę i respekt; energia odnawia się sama.' },
      { emoji: '💪', title: 'Trenuj i kupuj sprzęt', desc: 'Podnoś Siłę, Umiejętności, Wytrzymałość i Charyzmę oraz kupuj prawdziwy sprzęt, który wzmacnia statystyki.' },
      { emoji: '🏠', title: 'Zbuduj bazę', desc: 'Warsztat, sklep wędkarski… zarabia kasę co godzinę, gdy Cię nie ma.' },
      { emoji: '🥊', title: 'Wyzywaj freaków', desc: 'Wyzywaj graczy o podobnym respekcie i zabieraj część ich kasy. Nowi gracze są chronieni przez 7 dni.' },
      { emoji: '🎁', title: 'Codzienna nagroda i zadania', desc: 'Odbieraj nagrodę każdego dnia, wykonuj 3 codzienne zadania i utrzymuj passę.' },
    ],
    prizesHeading: 'Wygrywaj prawdziwe Freak Punkty',
    prizes: 'Top 3 każdego dnia wygrywa 30 / 20 / 10 Freak Punktów w rankingu Top Freaks, a top 3 miesiąca — 100 / 50 / 25 FP i medal.',
    ctaHeading: 'Gotowy do gry?',
    ctaSubline: 'Załóż darmowe konto albo zaloguj się, żeby zacząć grać w The Freaks.',
    register: 'Dołącz za darmo',
    login: 'Zaloguj się',
    back: 'Wróć do O nas',
    watchDemo: 'Zobacz demo',
    demo: {
      badge: 'Demo',
      captions: {
        intro: { title: 'To jest The Freaks', text: 'Codzienna gra Freaklandu dla Twojej aktywności. Tu: off-road.' },
        daily: { title: 'Odbierz codzienną nagrodę', text: 'Wracaj codziennie — passa płaci więcej.' },
        mission: { title: 'Wykonuj misje', text: 'Prawdziwe off-roadowe zadania. Wygrane dają kasę i respekt.' },
        repeat: { title: 'Mało czasu?', text: 'Powtórz misję ×5 jednym kliknięciem.' },
        train: { title: 'Trenuj statystyki', text: 'Siła, Umiejętności, Wytrzymałość, Charyzma — każda ma swoje zadanie.' },
        gear: { title: 'Kupuj sprzęt', text: 'Prawdziwy sprzęt wzmacnia Twoje statystyki w grze.' },
        base: { title: 'Prowadź bazę', text: 'Twój warsztat zarabia kasę co godzinę, nawet gdy Cię nie ma.' },
        fight: { title: 'Wyzywaj freaków', text: 'Pokonuj graczy o podobnym respekcie i zabieraj część ich kasy.' },
        outro: { title: 'Wspinaj się w Top Freaks', text: 'Top 3 dnia wygrywa prawdziwe Freak Punkty. Twoja kolej!' },
      },
      play: 'Odtwórz',
      pause: 'Pauza',
      next: 'Dalej',
      previous: 'Wstecz',
      restart: 'Od nowa',
      step: 'Krok %{step} z %{total}',
      backToGuide: 'Wróć do przewodnika',
    },
  },
};

export default theFreaksGuideTranslations;
